import { useMemo } from 'react';

import Query from 'views/logic/queries/Query';
import Search from 'views/logic/search/Search';
import SearchResult from 'views/logic/SearchResult';
import { VALID_ACTIVE_SEARCH_STATUSES } from 'data-lake/preview/Constants';
import useFetchActiveSearch from 'data-lake/preview/hooks/useFetchActiveSearch';

const useActiveSearch = (initialUrlParams: object) => {
  const hasInitialUrlParams = Object.entries(initialUrlParams).some(([key, value]) => key !== 'dataLakeId' && !!value);
  const { data, isLoading, refetch } = useFetchActiveSearch(!hasInitialUrlParams);

  return useMemo(() => {
    if (hasInitialUrlParams || !data || !VALID_ACTIVE_SEARCH_STATUSES.includes(data.status)) {
      return {
        search: undefined,
        result: undefined,
        isLoading,
        searchJob: {
          status: data?.status,
          progress: data?.progress,
          nodeId: data?.executing_node,
          id: data?.id,
        },
        refetch,
      };
    }

    const searchType = data.result.query.search_types[0];
    const query = Query.builder()
      .id(data.result.query.id)
      .query(data.result.query.query)
      .searchTypes([searchType])
      .build();

    return {
      isLoading,
      search: Search.create().toBuilder().id(data.search_id).queries([query]).build(),
      result: {
        result: new SearchResult({
          results: { [data.result.query.id]: data.result },
          id: data.id,
          owner: data.owner,
          search_id: data.search_id,
          errors: data.error_message,
          execution: { done: true, cancelled: false, completed_exceptionally: false },
        }),
      },
      searchJob: {
        progress: data.progress,
        status: data.status,
        nodeId: data.executing_node,
        id: data.id,
      },
      refetch,
    };
  }, [data, hasInitialUrlParams, isLoading, refetch]);
};

export default useActiveSearch;
